import React, { useState, useEffect } from "react"
import "./EditManageStaff.scss"
import { useHistory, useLocation } from "react-router"
import InputField from "../../../../components/InputField"
import Button from "../../../../components/Button"

import {
  addManageStaff,
  getAllCenters,
  getAllStaffRoles, getManageStaffDetailsById,
  sendOtpToVerifyStaffNumber,
  updateManageStaff,
  uploadSpecificFile,
  VerifyStaffOtp
} from "../../../../core/services/api"
import { genderOptions } from "../../../../components/patientEditForm/DropdownList"
import Select from "react-select"
import { useDispatch, useSelector } from "react-redux"
import { MocUserRole } from "../../../../core/services/models/Enums"
import Toast from "components/Toast"
import { countriesList } from "core/jsons/countries"
import customSelectStyles from "components/CustomSelect/CustomSelectStyle"
import userAction from "core/store/actions/userAction"
import fileUtils from "fileUtils"
import ToggleSwitch from "components/ToggleSwitch"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCircleUser } from "@fortawesome/free-regular-svg-icons"

function EditManageStaff(props: any) {
  const { origin } = props
  const history = useHistory()
  const location: any = useLocation()
  const dispatch = useDispatch()
  const id = location?.state?.idValue
  const userDetail = useSelector((state: any) => state?.user?.userDetail)
  const userRole = useSelector((state: any) => state?.user?.role)
  let readOnly = useSelector((state: any) => state?.user?.readOnly)


  const time: string[] = ["MORNING", "AFTERNOON", "EVENING"]
  const [sign, setSign] = useState<File | null>(null);
  const [formErrors, setFormErrors] = useState<any>()
  const [isSubmit, setIsSubmit] = useState(false)
  const [data, setData] = useState<any>()
  const [datatest, setDataTest] = useState<any>()
  const [primaryRoles, setPrimaryRoles] = useState<any>([])
  const [secondaryRoles, setSecondaryRoles] = useState<string[]>([])
  const [centers, setCenters] = useState<any>([])
  const [centerOptions, setCenterOptions] = useState<any>([])
  const [success, setSuccess] = useState<boolean>(false)
  const [message, setMessage] = useState<string>("")
  const [toastType, setToastType] = useState<string>("")
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [allowed, setAllowed] = useState<any>([])
  const [sendotp, setSendOTP] = useState<any>(false)
  const [checkOtp, setCheckOTP] = useState<any>()
  const [isVerifyOtp, setVerifyOtp] = useState<boolean>()
  const [sendemail, setSendEmail] = useState<any>()
  const [displayToast, toggleDisplayToast] = useState<any>()
  const [otpToast, toggleOtpToast] = useState<any>()
  const [manageStaffInfo, setManageStaffInfo] = useState<any>({
    id: "",
    name: "",
    primaryRole: "",
    secondaryRoles: [],
    contactNumber: "",
    gender: "",
    mocEmail: "",
    newPassword: "",
    signaturePicUrl: "",
    signatureContent: "",
    consultantProfilePic: "",
    location: [],
    specialization: "",
    servicesOffered: "",
    educationalQualification: "",
    summary: "",
    startDateOfPractice: "",
    startDateOfSpecialityPractice: "",
    colorCoding: "",
    countryCode: "",
    sendEmailOtp: false
  })
  const [isMenuOpen, setIsMenuOpen] = useState<any>(false)
  const [showSendOtpBtn, setShowSendOtpBtn] = useState<any>(false)
  const [currentContactNumber, setCurrentContactNumber] = useState<any>("")
  const [currentCountryCode, setCurrentCountryCode] = useState<any>("")
  console.log(id, "id in Edit Manage Staff");
  useEffect(() => {
    fetchAllStaffRolesDetails()
    fetchManageStaffDetailsById()
    if (
      userRole === MocUserRole?.SYSTEM_ADMIN ||
      userRole === MocUserRole?.CENTER_ADMIN
    ) {
      fetchCentersDetails()
    }
  }, [])

  useEffect(() => {
    const temp = []
    temp.push(manageStaffInfo?.primaryRole)
    setAllowed(Array.isArray(temp) && temp?.length > 0 ? temp : [])
  }, [manageStaffInfo?.primaryRole])

  useEffect(() => {
    console.log(formErrors, isSubmit)
    if (formErrors && Object.keys(formErrors).length === 0 && isSubmit) {
      const rolesList = manageStaffInfo.secondaryRoles.map((item: { label: any }) => {
        return item.label
      })
      let centersList: any
      if (manageStaffInfo?.primaryRole === "ACCOUNTANT" ||
        manageStaffInfo?.primaryRole === "QUALITY" ||
        manageStaffInfo?.primaryRole === "MARKETING" ||
        manageStaffInfo?.primaryRole === "INSURANCE" ||
        manageStaffInfo?.primaryRole === "SYSTEM_ADMIN" ||
        manageStaffInfo?.primaryRole === "OPERATIONS" ||
        manageStaffInfo?.primaryRole === "MRD" ||
        manageStaffInfo?.primaryRole === "MANAGEMENT") {
        centersList = null
      } else {
        centersList = manageStaffInfo?.location?.map((each: any) => each?.value)
      }

      let test: any = {
        centers: centersList,
        primaryRole: manageStaffInfo?.primaryRole,
        secondaryRoles: rolesList,
        name: manageStaffInfo.name,
        servicesOffered: manageStaffInfo?.servicesOffered ? [manageStaffInfo?.servicesOffered] : null,
        phoneNumber: manageStaffInfo.contactNumber,
        countryCode: manageStaffInfo?.countryCode,
        email: manageStaffInfo.mocEmail,
        specialization: manageStaffInfo?.specialization,
        educationalQualification: manageStaffInfo?.educationalQualification ? [manageStaffInfo?.educationalQualification] : null,
        summary: manageStaffInfo?.summary,
        startDateOfPractice: manageStaffInfo?.startDateOfPractice,
        startDateOfSpecialityPractice:
          manageStaffInfo?.startDateOfSpecialityPractice,
        consultantProfilePic: manageStaffInfo?.consultantProfilePic,
        colorCoding: manageStaffInfo?.colorCoding,
        gender: manageStaffInfo.gender,
        signaturePicUrl: manageStaffInfo.signaturePicUrl,
        signatureContent: manageStaffInfo.signatureContent,
        sendEmailOtp: manageStaffInfo?.sendEmailOtp
      }
      // setIsLoading(true)
      if (origin === "Add") {
        addManageStaff(id, test)
          .then((data) => {
            if (userDetail?.id === data?.id) {
              let listOfRoles: any = []
              if (data?.secondaryRoles?.length > 0) {
                listOfRoles = [...data?.secondaryRoles]
              }
              listOfRoles.push(data?.primaryRole)
              const sortedList: any = listOfRoles?.sort()
              updateStorageDetails(sortedList, centersList)
            }
            setIsLoading(false)
            setMessage("Staff Created Successfully")
            setToastType("success")
            setSuccess(true)
          })
          .catch((err) => {
            setIsLoading(false)
            setMessage(err?.response?.data?.message)
            setToastType("error")
            setSuccess(true)
          })
      } else {
        updateManageStaff(id, test)
          .then((data) => {
            if (userDetail?.id === data?.id) {
              let listOfRoles: any = []
              if (data?.secondaryRoles?.length > 0) {
                listOfRoles = [...data?.secondaryRoles]
              }
              listOfRoles.push(data?.primaryRole)
              const sortedList: any = listOfRoles?.sort()
              updateStorageDetails(sortedList, centersList)
            }
            setIsLoading(false)
            setMessage("Staff Details Added Successfully")
            setToastType("success")
            setSuccess(true)
          })
          .catch((err: any) => {
            setIsLoading(false)
            setMessage(err?.response?.data?.message)
            setToastType("error")
            setSuccess(true)
          })
      }
    }
  }, [formErrors])

  const handleFile = (e: any) => {
    const file = e?.target?.files[0]

    const invalidFile: any = !fileUtils.validateFileExtension(file?.name)
    if (invalidFile) {
      toggleDisplayToast({ text: "Uploaded file extension not allowed", type: "error" })
      return;
    }

    setSign(file)
    const formData = new FormData()
    formData.append("files", file)
    uploadSpecificFile(formData, true)
      .then((res: any) => {
        setManageStaffInfo({
          ...manageStaffInfo,
          ...{ signaturePicUrl: res[0] },
        })
      })
      .catch((err: any) => {
        console.log(err?.message)
      })
  }

  const fetchManageStaffDetailsById = () => {
    if (id && origin !== "Add") {
      getManageStaffDetailsById(id)
        .then((res) => {
          setData(res)
          setDataTest(res)
          const tempRoles = res?.secondaryRoles?.map((each: any) => {
            return { label: each, value: each }
          })
          const tempCenters = res?.centers?.map((eachCenter: any) => {
            return {
              label: `${eachCenter?.centerName}`,
              value: {
                centerId: eachCenter?.centerId,
                centerName: eachCenter?.centerName,
                mocCenterId: eachCenter?.mocCenterId,
                brandName: eachCenter?.brandName,
                companyName: eachCenter?.companyName
              },
            }
          })
          setCurrentContactNumber(res?.phoneNumber)
          setCurrentCountryCode(res?.countryCode ? res?.countryCode : "+91")
          setManageStaffInfo({
            id: res?.id,
            name: res.name,
            primaryRole: res?.primaryRole,
            secondaryRoles: tempRoles,
            contactNumber: res.phoneNumber,
            gender: res.gender,
            mocEmail: res.email,
            newPassword: "",
            signaturePicUrl: res?.signaturePicUrl,
            signatureContent: res.signatureContent,
            consultantProfilePic: res.consultantProfilePic,
            location: tempCenters,
            servicesOffered: res?.servicesOffered && res?.servicesOffered[0],
            specialization: res?.specialization,
            educationalQualification: res?.educationalQualification && res?.educationalQualification[0],
            summary: res?.summary,
            startDateOfPractice: res?.startDateOfPractice,
            startDateOfSpecialityPractice: res?.startDateOfSpecialityPractice,
            colorCoding: res?.colorCoding,
            countryCode: res?.countryCode ? res?.countryCode : "+91",
            mocConsultantId: res?.mocConsultantId ? res?.mocConsultantId : "",
            sendEmailOtp: res?.sendEmailOtp ? res?.sendEmailOtp : false
          })
        })
        .catch((err) => {
          console.log("Err,", err)
        })
    }
  }
  const signatureUrl = manageStaffInfo.signaturePicUrl;
  const fetchAllStaffRolesDetails = () => {
    getAllStaffRoles()
      .then((res) => {
        const rolesDetailsArray = res.map(
          (elem: { mocId: any; name: any; id: any }) => {
            return {
              label: `${elem}`,
              value: elem,
            }
          }
        )
        setPrimaryRoles(rolesDetailsArray)
        setSecondaryRoles(rolesDetailsArray)
      })
      .catch((err) => {
        console.log("error", err)
      })
  }

  const fetchCentersDetails = () => {
    getAllCenters().then((res: any) => {
      setCenters(res)
      const centerDetailsArray = res.map((c: any) => {
        return {
          label: `${c?.centerName}`,
          value: {
            centerId: c?.id,
            centerName: c?.centerName,
            mocCenterId: c?.mocCenterId,
            brandName: c?.brandName,
            companyName: c?.companyName
          },
        }
      })
      setCenterOptions(centerDetailsArray)
    })
  }

  const handleSubmit = (e: any) => {
    e.stopPropagation()
    e.preventDefault()
    setFormErrors(validate(manageStaffInfo))
    setIsSubmit(true)
  }

  const validate = (values: any) => {
    const errors: any = {}
    const regex =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1, 3}\.[0-9]{1, 3}\.[0-9]{1, 3}\.[0-9]{1, 3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    if (!values?.name) {
      errors["name"] = "Name is required"
    }
    if (!values?.primaryRole) {
      errors["primaryRole"] = "Primary Role is required"
    }
    if (!values?.countryCode) {
      errors["countryCode"] = "Country Code is required"
    }
    if (!values?.contactNumber) {
      errors["contactNumber"] = "Contact Number is required"
    }
    if (values?.countryCode === "+91" && values?.contactNumber?.length !== 10) {
      errors["contactNumber"] = "Please enter correct contact number"
    }
    if (!values.mocEmail) {
      errors["mocEmail"] = "MOC Email is required"
    }
    if (!values?.gender) {
      errors.gender = "Gender is required"
    }


    if (
      !(
        allowed.includes("RMO") ||
        allowed.includes("NURSE") ||
        allowed.includes("SYSTEM_ADMIN") ||
        allowed.includes("CENTER_ADMIN") ||
        allowed.includes("FRONT_DESK") ||
        allowed.includes("BILL_DESK") ||
        allowed.includes("INSURANCE") ||
        allowed.includes("MARKETING") ||
        // allowed.includes("PATIENT_COORDINATOR") ||
        allowed.includes("QUALITY") ||
        allowed.includes("MANAGEMENT") ||
        allowed.includes("OPERATIONS") ||
        allowed.includes("ACCOUNTANT") ||
        allowed.includes("MRD")
      )
    ) {
      if (!values.signaturePicUrl) {
        errors["signaturePicUrl"] = "Signature  image is required"
      }
      // if (!values.signatureContent) {
      //   errors["signatureContent"] = "Signature Content is required"
      // }
    }

    if (values.mocEmail && !regex.test(values.mocEmail)) {
      errors["mocEmail"] = "This is not a valid email format!"
    }
    if (!(allowed.includes("ACCOUNTANT") ||
      allowed.includes("QUALITY") ||
      allowed.includes("MARKETING") ||
      allowed.includes("INSURANCE") ||
      allowed.includes("SYSTEM_ADMIN") ||
      allowed.includes("OPERATIONS") ||
      allowed.includes("MANAGEMENT") ||
      allowed.includes("MRD"))) {
      if (userRole === MocUserRole.SYSTEM_ADMIN && values.location?.length === 0) {
        errors["location"] = "Location is required"
      }
    }
    return errors
  }

  const handleUploadProfPic = (e: any) => {
    const file = e?.target?.files[0]

    const invalidFile: any = !fileUtils.validateFileExtension(file?.name)
    if (invalidFile) {
      toggleDisplayToast({ text: "Uploaded file extension not allowed", type: "error" })
      return;
    }

    const formData = new FormData()
    formData.append("files", file)
    uploadSpecificFile(formData, true)
      .then((res: any) => {
        setManageStaffInfo({
          ...manageStaffInfo,
          ...{ consultantProfilePic: res[0] },
        })
      })
      .catch((err: any) => {
        console.log(err?.message)
      })
  }

  const handleSendotp = (e: any) => {
    e.stopPropagation();
    e.preventDefault();
    // setSendOTP(true)
    if (manageStaffInfo?.contactNumber?.length === 10 && manageStaffInfo?.countryCode === "+91") {
      sendOtpToVerifyStaffNumber(manageStaffInfo?.contactNumber)
        .then((res) => {
          setSendOTP(true)

        })
        .catch((err) => {
          if (err) {
            setSendOTP(false)
            toggleDisplayToast({
              text: err?.response?.data?.message,
              type: "error",
            })
          }
        })
    } else {
      toggleOtpToast({ text: "Please enter correct contact details to receive otp", type: "error" })
    }
  }

  const handleVerifyotp = (e: any) => {
    e.stopPropagation();
    e.preventDefault();
    if (manageStaffInfo?.contactNumber)
      VerifyStaffOtp(manageStaffInfo?.contactNumber, checkOtp)
        .then((res) => {
          setVerifyOtp(true)
        })
        .catch((err) => {
          setVerifyOtp(false)
          toggleDisplayToast({
            text: err?.response?.data?.message,
            type: "error",
          })
        })
  }

  const handleSendEmail = (e: any) => {
    e.stopPropagation();
    e.preventDefault();
    setSendEmail(true)
  }

  const getLocationValue = () => {
    const filteredArray: any = centerOptions.filter((obj: any) => {
      return manageStaffInfo?.location?.some((filterObj: any) => {
        return filterObj?.value?.centerId === obj?.value?.centerId
      })
    });
    return filteredArray
  }

  const updateStorageDetails = (rolesList: any, centersList: any) => {
    const tempUserDetails: any = { ...userDetail }
    tempUserDetails["roles"] = rolesList
    tempUserDetails["centers"] = centersList?.length ? centersList : []
    //Update Redux Store
    dispatch(userAction.setUser(tempUserDetails))
    //Update Session Storage
    sessionStorage.setItem('userDetails', JSON.stringify(tempUserDetails))
  }

  return (
    <div className="edit-manage-staff-wrapper">
      {success ? (
        <><div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            zIndex: 9998,
          }}
        >
        </div>
          <Toast
            textMessage={message}
            onCloseText={"Close"}
            onClose={() => {
              setSuccess(false)
              if (toastType !== "error") {
                history.push(`/manageStaff`)
              }
            }}
            type={toastType}
          ></Toast></>
      ) : isLoading ? (
        <div
          style={{
            position: "absolute",
            top: "50%",
            right: "50%",
          }}
        >
          <div
            style={{ width: "3rem", height: "3rem" }}
            className="spinner-border text-primary"
          ></div>
        </div>
      ) : (
        ""
      )}

      {displayToast ? (
        <><div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            zIndex: 9998,
          }}
        >
        </div>
          <Toast
            textMessage={displayToast?.text}
            onCloseText={"Close"}
            onClose={() => {
              toggleDisplayToast(false)
            }}
            type="error"
          ></Toast></>
      ) : otpToast ? (
        <><div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            zIndex: 9998,
          }}
        >
        </div>
          <Toast
            textMessage={otpToast?.text}
            type={otpToast?.type}
            onClose={() => toggleOtpToast(false)}
            onCloseText="Close"
            onClickText={null}
          /></>
      ) : null}

      {origin !== "Add" && (
        <div
          className="approval-back-image"
          onClick={() => {
            history.push("/manageStaff")
          }}
        >
          <img
            src={"../../../assets/images/back-icon.svg"}
            height={"60px"}
            width={"60px"}
            alt="back button"
            className="back_button"
          />
          <div className="edit-manage-staff-heading">Edit Staff</div>
        </div>
      )}
      <form onSubmit={handleSubmit}>
        <div className="edit-details-wrapper">
          <div className="edit-details-container">
            {origin === "Add" ? (
              <div className="edit-details-heading">Add Details</div>
            ) : (
              <div className="edit-details-heading">
                Edit Details - {manageStaffInfo?.name}
              </div>
            )}
            {
              (id && manageStaffInfo?.mocConsultantId) && (
                <div className="edit-details-heading">MOC ID : {manageStaffInfo?.mocConsultantId}</div>
              )
            }
            <div className="manage-staff-details">
              <div className="col-md-6 col-lg-6 staff_details">
                <div className="col-2">
                  {manageStaffInfo?.consultantProfilePic ?
                    <img
                      className="img_source"
                      src={manageStaffInfo?.consultantProfilePic}
                      alt="image"
                      width="75%"
                    /> : <FontAwesomeIcon icon={faCircleUser} size="3x" />
                  }
                  <input
                    type="file"
                    disabled={readOnly}
                    onChange={(e: any) => handleUploadProfPic(e)}
                    id="consultantProfilePic"
                    className="consultantProfilePicInput"
                  />
                  <label
                    className="consultantProfilePicUpload"
                    htmlFor="consultantProfilePic"
                  >
                    Upload
                  </label>
                </div>
              </div>
              <div className="col-md-4 col-lg-4 staff_details"></div>
              <div className="col-md-4 col-lg-4 staff_details">
                <div>
                  <label className="textlabel">* Staff Name:</label>
                </div>
                {/* <div className="col-3"> */}
                <InputField
                  className="col-md-10"
                  placeholder="Enter Name"
                  readOnly={readOnly}
                  value={manageStaffInfo?.name}
                  handleChange={(e) =>
                    setManageStaffInfo({
                      ...manageStaffInfo,
                      name: e.target.value,
                    })
                  }
                  errorMsg={formErrors?.name}
                />
                {/* </div> */}
              </div>
              <div className="col-md-4 col-lg-4 staff_details">
                <div>
                  <label className="textlabel">* Primary Role:</label>
                </div>
                <div className="col-md-10 patientIdContainer">
                  <Select
                    isDisabled={id || readOnly}
                    styles={customSelectStyles()}
                    value={primaryRoles?.filter((p: any) => p?.value === manageStaffInfo?.primaryRole)}
                    placeholder="Select Primary Role"
                    isSearchable={true}
                    options={primaryRoles}
                    onChange={(option: any) => {
                      setManageStaffInfo({
                        ...manageStaffInfo,
                        primaryRole: option?.value,
                      })
                    }}
                  />
                  <span className="error-staff">{formErrors?.primaryRole}</span>
                </div>
              </div>
              <div className="col-md-4 col-lg-4 staff_details">
                <div>
                  <label className="textlabel">Secondary Roles:</label>
                </div>
                <div className="col-md-10 patientIdContainer">
                  <Select
                    styles={customSelectStyles()}
                    options={[...secondaryRoles]?.filter((each: any) => {
                      return each?.label !== manageStaffInfo?.primaryRole
                    })}
                    value={manageStaffInfo?.secondaryRoles}
                    isDisabled={readOnly || userRole !== MocUserRole.SYSTEM_ADMIN}
                    onChange={(option) => {
                      let filteredArray = [...option];
                      // Check if the user is not SYSTEM_ADMIN
                      if (userRole !== MocUserRole.SYSTEM_ADMIN) {
                        const hasSystemAdmin = manageStaffInfo?.secondaryRoles.some((role: any) => role.label === "SYSTEM_ADMIN");
                        const isSystemAdminBeingAdded = option.some(obj => obj.label === "SYSTEM_ADMIN");
                        const isSystemAdminBeingRemoved = hasSystemAdmin && !filteredArray.some(obj => obj.label === "SYSTEM_ADMIN");

                        // If SYSTEM_ADMIN is being added and it's not already present, do nothing
                        if (isSystemAdminBeingAdded && !hasSystemAdmin) {
                          return;
                        }

                        // If SYSTEM_ADMIN is being removed but it is present in secondary roles, revert to the original roles
                        if (isSystemAdminBeingRemoved) {
                          filteredArray = [...manageStaffInfo.secondaryRoles];
                        }
                      }
                      setManageStaffInfo({
                        ...manageStaffInfo,
                        secondaryRoles: filteredArray,
                      });
                    }}
                    isMulti
                    onFocus={() => {
                      setIsMenuOpen(true)
                    }}
                    onBlur={() => {
                      setIsMenuOpen(false)
                    }}
                    menuIsOpen={isMenuOpen}
                  />
                  {formErrors?.secondaryRoles && (
                    <span className="error-staff">{formErrors?.secondaryRoles}</span>
                  )}
                </div>
              </div>
              <div className="col-md-12 col-lg-12 staff_details">
                <div className="d-flex align-center ">
                  <div className="col-md-2">
                    <label htmlFor="" className="textlabel">
                      * Code
                    </label>
                    <div>
                      <Select
                        className="country-select"
                        isDisabled={readOnly}
                        styles={customSelectStyles()}
                        value={countriesList?.map((eachCountry) => {
                          return {
                            label: `${eachCountry?.dial_code}`,
                            value: eachCountry?.dial_code,
                          }
                        })?.filter(({ label }: any) => {
                          return label === manageStaffInfo?.countryCode
                        })}
                        placeholder={manageStaffInfo?.countryCode}
                        isSearchable={true}
                        options={countriesList?.map((eachCountry) => {
                          return {
                            label: `${eachCountry?.dial_code}`,
                            value: eachCountry?.dial_code,
                          }
                        })}
                        onChange={(option: any) => {
                          setManageStaffInfo({
                            ...manageStaffInfo,
                            countryCode: option?.value,
                          })
                          if (option?.value && option?.value !== currentCountryCode && option?.value === "+91" && manageStaffInfo?.contactNumber?.length === 10) {
                            setShowSendOtpBtn(true)
                          }
                        }}
                      />
                      {formErrors?.countryCode && (
                        <span className="error-staff">{formErrors?.countryCode}</span>
                      )}
                    </div>
                  </div>
                  <div className="col-md-3" style={{ paddingLeft: "10px" }}>
                    <label className="textlabel">* Contact Number:</label>
                    <InputField
                      placeholder="Enter Contact Number"
                      value={manageStaffInfo?.contactNumber}
                      handleChange={(e: any) => {
                        const value = e.target.value
                        setSendOTP(false)
                        let res = ""
                        value?.split("")?.forEach((ele: any) => {
                          let k = ele?.charCodeAt(0)
                          if (k >= 48 && k <= 57) {
                            res += ele
                          }
                        })
                        if (res && res !== currentContactNumber) {
                          setManageStaffInfo({
                            ...manageStaffInfo,
                            contactNumber: res,
                          })
                          setShowSendOtpBtn(true)
                        } else if (res && res === currentContactNumber) {
                          setManageStaffInfo({
                            ...manageStaffInfo,
                            contactNumber: res,
                          })
                          setShowSendOtpBtn(false)
                        } else if (res?.length < 10) {
                          setManageStaffInfo({
                            ...manageStaffInfo,
                            contactNumber: res,
                          })
                        }
                      }}
                      readOnly={readOnly ? true :
                        isVerifyOtp !== true
                          ? false
                          : true}
                      errorMsg={formErrors?.contactNumber}
                    />
                  </div>
                  <div className="col-md-2 col-lg-2" style={{ paddingLeft: "10px" }}>
                    <label className="textlabel"></label>
                    {
                      showSendOtpBtn && manageStaffInfo?.countryCode === "+91" && manageStaffInfo?.contactNumber?.length === 10 && (
                        <div>
                          <Button
                            type={"button"}
                            disabled={
                              readOnly ? true :

                                !isVerifyOtp
                                  ? false
                                  : true
                            }
                            text={
                              sendotp ? "Resend OTP" : "Send OTP"
                            } onClick={(e: any) => handleSendotp(e)}
                          />
                        </div>
                      )
                    }
                  </div>
                  {sendotp && manageStaffInfo?.countryCode === "+91" && manageStaffInfo?.contactNumber?.length === 10 && (
                    <>
                      <div className="col-md-3">
                        <label className="textlabel">Enter OTP:</label>
                        <InputField
                          placeholder="Enter OTP"
                          value={checkOtp}
                          readOnly={
                            isVerifyOtp ? true : false
                          }
                          handleChange={(e: any) => setCheckOTP(e.target.value)}
                        />
                      </div>
                      <div className="col-md-1 col-lg-1" style={{ paddingLeft: "10px" }}>
                        <label className="textlabel"></label>
                        <div>
                          <Button
                            type={"button"}
                            disabled={
                              isVerifyOtp ? true : false
                            }
                            text={" Verify OTP"}
                            onClick={(e) => handleVerifyotp(e)}
                          />
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </div>
              <div className="col-md-6 col-lg-6 staff_details">
                <div className="row">
                  <label htmlFor="" className="textlabel">
                    * Gender:
                  </label>
                  <div className="col-md-8">
                    <Select
                      className="country-select"
                      placeholder="Gender"
                      isSearchable={true}
                      styles={customSelectStyles()}
                      isDisabled={readOnly}
                      options={genderOptions?.map((item) => {
                        return {
                          label: item,
                          value: item,
                        }
                      })}
                      onChange={(option: any) => {

                        setManageStaffInfo({
                          ...manageStaffInfo,
                          gender: option?.label,
                        })
                      }}
                      value={genderOptions?.map((item: any) => {
                        return {
                          label: item,
                          value: item,
                        }
                      })?.filter(
                        ({ value }: any) => value === manageStaffInfo?.gender
                      )}
                    />
                    {formErrors?.gender && (
                      <span className="error-staff">{formErrors?.gender}</span>
                    )}
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-lg-6 staff_details">
                <div className="row">
                  <label className="textlabel">* MOC Email:</label>
                  <InputField
                    placeholder="Enter MOC email"
                    className="col-md-8"
                    value={manageStaffInfo?.mocEmail}
                    handleChange={(e) =>
                      setManageStaffInfo({
                        ...manageStaffInfo,
                        mocEmail: e.target.value,
                      })
                    }
                    errorMsg={formErrors?.mocEmail}
                    readOnly={readOnly ? true : origin !== "Add" ? true : false}
                  />
                  {/* <div className="col-md-1 col-lg-1">
                    <Button
                      type={"sucess"}
                      text={" Send Email"}
                      onClick={(e: any) => handleSendEmail(e)}
                    />
                  </div> */}
                </div>
              </div>
              {!(
                allowed.includes("RMO") ||
                allowed.includes("NURSE") ||
                allowed.includes("SYSTEM_ADMIN") ||
                allowed.includes("CENTER_ADMIN") ||
                allowed.includes("FRONT_DESK") ||
                allowed.includes("BILL_DESK") ||
                allowed.includes("INSURANCE") ||
                allowed.includes("MARKETING") ||
                // allowed.includes("PATIENT_COORDINATOR") ||
                allowed.includes("QUALITY") ||
                // allowed.includes("HOME_CARE_RMO") ||
                // allowed.includes("HOME_CARE_NURSE") ||
                allowed.includes("MANAGEMENT") ||
                allowed.includes("OPERATIONS") ||
                allowed.includes("ACCOUNTANT") ||
                allowed.includes("MRD")
              ) && (
                  <div className="col-md-6 col-lg-6 staff_details">
                    <div>
                      <label className="textlabel">* Signature:</label>
                      {signatureUrl ? (
                        <a href={signatureUrl} download>View Signature</a>
                      ) : (
                        <p></p>
                      )}
                    </div>
                    <InputField
                      className="col-md-8"
                      placeholder="Enter Signature"
                      file={true}
                      readOnly={readOnly}
                      filename={"Signature File"}
                      handleChange={(e) => {
                        handleFile(e)
                      }}
                      errorMsg={formErrors?.signaturePicUrl}
                    />

                    {/* generating sign image url */}
                    {sign && (
                      <a href={URL.createObjectURL(sign)} download={sign.name}>
                        {sign.name}
                      </a>
                    )}
                  </div>

                )}
              {/* {sendemail && <div className="col-md-6 col-lg-6 staff_detailss">
                <p className="textlabel">Email Verified</p>
              </div>} */}
              {!(
                allowed.includes("RMO") ||
                allowed.includes("NURSE") ||
                allowed.includes("SYSTEM_ADMIN") ||
                allowed.includes("CENTER_ADMIN") ||
                allowed.includes("FRONT_DESK") ||
                allowed.includes("BILL_DESK") ||
                allowed.includes("INSURANCE") ||
                allowed.includes("MARKETING") ||
                // allowed.includes("PATIENT_COORDINATOR") ||
                allowed.includes("QUALITY") ||
                allowed.includes("MANAGEMENT") ||
                allowed.includes("OPERATIONS") ||
                allowed.includes("ACCOUNTANT") ||
                allowed.includes("MRD")
              ) && (
                  <div className="col-md-6 col-lg-6 staff_details">
                    <div>
                      <label className="textlabel">Signature Content:</label>
                    </div>
                    {/* <InputField
                      className="col-md-8"
                      placeholder="Enter Signature content"
                      readOnly={readOnly}
                      value={manageStaffInfo?.signatureContent}
                      handleChange={(e) => {
                        setManageStaffInfo({
                          ...manageStaffInfo,
                          signatureContent: e.target.value,
                        })
                      }}
                      errorMsg={formErrors?.signatureContent}
                    /> */}
                    <textarea
                      className="col-md-8"
                      placeholder="Enter Signature content"
                      disabled={readOnly}
                      value={manageStaffInfo?.signatureContent}
                      onChange={(e) => {
                        setManageStaffInfo({
                          ...manageStaffInfo,
                          signatureContent: e.target.value,
                        })
                      }}
                    />
                    {
                      formErrors?.signatureContent && <div style={{ color: "red" }}>{formErrors?.signatureContent}</div>
                    }
                  </div>
                )}
              <div className="col-md-6 col-lg-6 staff_details">
                <div>
                  <label className="textlabel">
                    Educational Qualification:
                  </label>
                </div>
                <InputField
                  className="col-md-8"
                  placeholder="Education Qualification"
                  readOnly={readOnly}
                  value={manageStaffInfo?.educationalQualification}
                  handleChange={(e) => {
                    setManageStaffInfo({
                      ...manageStaffInfo,
                      educationalQualification: e.target.value,
                    })
                  }}
                  errorMsg={formErrors?.educationalQualification}
                />
              </div>
              {!(
                allowed.includes("RMO") ||
                allowed.includes("NURSE") ||
                allowed.includes("SYSTEM_ADMIN") ||
                allowed.includes("CENTER_ADMIN") ||
                allowed.includes("FRONT_DESK") ||
                allowed.includes("BILL_DESK") ||
                allowed.includes("INSURANCE") ||
                allowed.includes("MARKETING") ||
                // allowed.includes("PATIENT_COORDINATOR") ||
                allowed.includes("QUALITY") ||
                allowed.includes("HOME_CARE_RMO") ||
                allowed.includes("HOME_CARE_NURSE") ||
                allowed.includes("MANAGEMENT") ||
                allowed.includes("OPERATIONS") ||
                allowed.includes("ACCOUNTANT") ||
                allowed.includes("MRD")
              ) && (
                  <div className="col-md-6 col-lg-6 staff_details">
                    <div>
                      <label className="textlabel">Services Offered:</label>
                    </div>
                    <InputField
                      className="col-md-8"
                      placeholder="Service Offered"
                      readOnly={readOnly}
                      value={manageStaffInfo?.servicesOffered}
                      handleChange={(e) => {
                        setManageStaffInfo({
                          ...manageStaffInfo,
                          servicesOffered: e.target.value,
                        })
                      }}
                      errorMsg={formErrors?.servicesOffered}
                    />
                  </div>
                )}
              {!(
                allowed.includes("RMO") ||
                allowed.includes("NURSE") ||
                allowed.includes("SYSTEM_ADMIN") ||
                allowed.includes("CENTER_ADMIN") ||
                allowed.includes("FRONT_DESK") ||
                allowed.includes("BILL_DESK") ||
                allowed.includes("INSURANCE") ||
                allowed.includes("MARKETING") ||
                // allowed.includes("PATIENT_COORDINATOR") ||
                allowed.includes("QUALITY") ||
                allowed.includes("HOME_CARE_RMO") ||
                allowed.includes("HOME_CARE_NURSE") ||
                allowed.includes("MANAGEMENT") ||
                allowed.includes("OPERATIONS") ||
                allowed.includes("ACCOUNTANT") ||
                allowed.includes("MRD")
              ) && (
                  <div className="col-md-6 col-lg-6 staff_details">
                    <div>
                      <label className="textlabel">Specialization:</label>
                    </div>
                    <InputField
                      className="col-md-8"
                      placeholder="Specialization"
                      value={manageStaffInfo?.specialization}
                      readOnly={readOnly}
                      handleChange={(e) => {
                        setManageStaffInfo({
                          ...manageStaffInfo,
                          specialization: e.target.value,
                        })
                      }}
                      errorMsg={formErrors?.specialization}
                    />
                  </div>
                )}
              <div className="col-md-6 col-lg-6 staff_details">
                <div>
                  <label className="textlabel">Summary:</label>
                </div>
                <InputField
                  className="col-md-8"
                  placeholder="Summary"
                  readOnly={readOnly}
                  value={manageStaffInfo?.summary}
                  handleChange={(e) => {
                    setManageStaffInfo({
                      ...manageStaffInfo,
                      summary: e.target.value,
                    })
                  }}
                  errorMsg={formErrors?.summary}
                />
              </div>
              {!(
                allowed.includes("RMO") ||
                allowed.includes("NURSE") ||
                allowed.includes("SYSTEM_ADMIN") ||
                allowed.includes("CENTER_ADMIN") ||
                allowed.includes("FRONT_DESK") ||
                allowed.includes("BILL_DESK") ||
                allowed.includes("INSURANCE") ||
                allowed.includes("MARKETING") ||
                // allowed.includes("PATIENT_COORDINATOR") ||
                allowed.includes("QUALITY") ||
                allowed.includes("MANAGEMENT") ||
                allowed.includes("HOME_CARE_RMO") ||
                allowed.includes("HOME_CARE_NURSE") ||
                allowed.includes("OPERATIONS") ||
                allowed.includes("ACCOUNTANT") ||
                allowed.includes("MRD")
              ) && (
                  <div className="col-md-6 col-lg-6 staff_details">
                    <div>
                      <label className="textlabel">Start Date Of Practice:</label>
                    </div>
                    <InputField
                      className="col-md-8"
                      readOnly={readOnly}
                      placeholder="Start Date Of Practice"
                      value={manageStaffInfo?.startDateOfPractice}
                      handleChange={(e) => {
                        setManageStaffInfo({
                          ...manageStaffInfo,
                          startDateOfPractice: e.target.value,
                        })
                      }}
                      type="date"
                      errorMsg={formErrors?.startDateOfPractice}
                    />
                  </div>
                )}
              {!(
                allowed.includes("RMO") ||
                allowed.includes("NURSE") ||
                allowed.includes("SYSTEM_ADMIN") ||
                allowed.includes("CENTER_ADMIN") ||
                allowed.includes("FRONT_DESK") ||
                allowed.includes("BILL_DESK") ||
                allowed.includes("INSURANCE") ||
                allowed.includes("MARKETING") ||
                allowed.includes("HOME_CARE_RMO") ||
                // allowed.includes("PATIENT_COORDINATOR") ||
                allowed.includes("QUALITY") ||
                allowed.includes("HOME_CARE_NURSE") ||
                allowed.includes("MANAGEMENT") ||
                allowed.includes("OPERATIONS") ||
                allowed.includes("ACCOUNTANT") ||
                allowed.includes("MRD")
              ) && (
                  <div className="col-md-6 col-lg-6 staff_details">
                    <div>
                      <label className="textlabel">
                        Start Date Of Speciality Practice:
                      </label>
                    </div>
                    <InputField
                      readOnly={readOnly}
                      className="col-md-8"
                      placeholder="Start Date Of Speciality Practice"
                      value={manageStaffInfo?.startDateOfSpecialityPractice}
                      handleChange={(e) => {
                        setManageStaffInfo({
                          ...manageStaffInfo,
                          startDateOfSpecialityPractice: e.target.value,
                        })
                      }}
                      type="date"
                      errorMsg={formErrors?.startDateOfSpecialityPractice}
                    />
                  </div>
                )}
              {!(
                allowed.includes("RMO") ||
                allowed.includes("NURSE") ||
                allowed.includes("SYSTEM_ADMIN") ||
                allowed.includes("CENTER_ADMIN") ||
                allowed.includes("FRONT_DESK") ||
                allowed.includes("BILL_DESK") ||
                allowed.includes("INSURANCE") ||
                allowed.includes("MARKETING") ||
                // allowed.includes("PATIENT_COORDINATOR") ||
                allowed.includes("QUALITY") ||
                allowed.includes("MANAGEMENT") ||
                allowed.includes("HOME_CARE_RMO") ||
                allowed.includes("OPERATIONS") ||
                allowed.includes("HOME_CARE_NURSE") ||
                allowed.includes("ACCOUNTANT") ||
                allowed.includes("MRD")
              ) && (
                  <div className="col-md-6 col-lg-6 staff_details">
                    <div>
                      <label className="textlabel">Color Code:</label>
                    </div>
                    <InputField
                      className="col-md-8"
                      placeholder="Color Code"
                      readOnly={readOnly}
                      type="color"
                      value={manageStaffInfo?.colorCoding}
                      handleChange={(e) => {
                        setManageStaffInfo({
                          ...manageStaffInfo,
                          colorCoding: e.target.value,
                        })
                      }}
                      errorMsg={formErrors?.colorCoding}
                    />
                  </div>
                )}
              {userRole === MocUserRole.SYSTEM_ADMIN ? (
                <div className="col-md-6 col-lg-6 staff_details">
                  {!(allowed.includes("ACCOUNTANT") ||
                    allowed.includes("QUALITY") ||
                    allowed.includes("MARKETING") ||
                    allowed.includes("INSURANCE") ||
                    allowed.includes("SYSTEM_ADMIN") ||
                    allowed.includes("OPERATIONS") ||
                    allowed.includes("MANAGEMENT") ||
                    allowed.includes("MRD")) && (
                      <><div>
                        <label className="textlabel">* Location:</label>
                      </div><div className="col-md-8 patientIdContainer">
                          <Select
                            options={centerOptions}
                            styles={customSelectStyles()}
                            value={getLocationValue()}
                            isDisabled={readOnly}
                            onChange={(option: any) => {
                              setManageStaffInfo({
                                ...manageStaffInfo,
                                location: option,
                              })
                            }}
                            isMulti
                          />
                          <span className="error-staff">{formErrors?.location}</span>
                        </div></>
                    )}
                </div>
              ) : (
                ""
              )}
              {(userRole === MocUserRole.SYSTEM_ADMIN || userRole === MocUserRole.CENTER_ADMIN) && (
                <div className="col-md-6 col-lg-6 staff_details">
                  <label className="textlabel">
                    Send OTP in Email
                  </label>
                  <div className="vip">
                    <ToggleSwitch
                      checked={manageStaffInfo?.sendEmailOtp}
                      onChange={(e: any) =>
                        setManageStaffInfo({
                          ...manageStaffInfo,
                          sendEmailOtp: e.target.checked,
                        })
                      }
                    />
                  </div>
                </div>
              )}
            </div>
            <div className="button-alignment">
              <div>
                <Button
                  text="Cancel"
                  type={"button"}
                  outline={true}
                  disabled={readOnly}
                  onClick={() => history.push(`/manageStaff`)}
                  id="cancel"
                />
              </div>
              <div>
                {
                  id && (
                    allowed.includes("CONSULTANT") ||
                    allowed.includes("HOME_CARE_NURSE") ||
                    allowed.includes("HOME_CARE_RMO") ||
                    allowed.includes("HOME_CARE_NURSE") ||
                    allowed.includes("GENETIC_COUNSELLOR") ||
                    allowed.includes("PSYCHOLOGIST") ||
                    allowed.includes("PHYSIOTHERAPIST") ||
                    allowed.includes("NUTRITIONIST")
                  ) ?
                    <div>
                      <Button
                        text="Absence List"
                        type="button"
                        disabled={readOnly}
                        onClick={() =>
                          history.push({
                            pathname: "/editStaffUnavailability",
                            state: { idValue: id },
                          })
                        }
                        id="save"
                      />
                    </div>
                    :
                    null
                }


              </div>
              <div>
                <Button
                  text={id ? "Update" : "Save"}
                  type="submit"
                  disabled={readOnly}
                  // onClick={handleSubmit}
                  id="save"
                />
              </div>
              {
                id && (
                  allowed.includes("CONSULTANT") ||
                  allowed.includes("HOME_CARE_NURSE") ||
                  allowed.includes("HOME_CARE_RMO") ||
                  allowed.includes("HOME_CARE_NURSE") ||
                  allowed.includes("GENETIC_COUNSELLOR") ||
                  allowed.includes("PSYCHOLOGIST") ||
                  allowed.includes("PHYSIOTHERAPIST") ||
                  allowed.includes("NUTRITIONIST")
                ) ?
                  <div>
                    <Button
                      text="Set Availability"
                      type="button"
                      disabled={readOnly}
                      onClick={(event: any) => {
                        event.preventDefault()
                        event.stopPropagation()
                        history.push({
                          pathname: "/editStaffAvailability",
                          state: { idValue: id },
                        })
                      }}
                      id="save"
                    />
                  </div>
                  :
                  null
              }
            </div>
          </div>
        </div>
      </form >
    </div >
  )
}
export default EditManageStaff
